var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMissedCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    name: "icon-missed-call",
    width: 17,
    height: 17,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99443 0L0.52287 0.221675C0.227419 0.221675 0.00582994 0.517241 0.00582994 0.738916C-0.068033 4.50739 0.522871 7.83251 3.92056 11.2315C7.31826 14.6305 10.4944 15 14.2614 15C14.5568 15 14.7784 14.7783 14.7784 14.4828L15 11.0099C15 10.7143 14.7784 10.4926 14.5568 10.4187L11.0853 9.90148C10.9375 9.90148 10.716 9.90148 10.6421 10.0493C9.8296 10.8621 9.23869 11.4532 9.0171 11.601C8.64779 11.4532 7.31826 10.8621 5.841 9.31034C4.36374 7.83251 3.62511 6.35468 3.40352 5.98522C3.69898 5.68965 4.36374 5.02463 4.95464 4.4335C5.10237 4.28571 5.10237 4.13793 5.10237 3.99015L4.58533 0.44335C4.58533 0.221675 4.28988 0 3.99443 0Z",
    fill: "#D2D2D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6494 4.5492H11.293V6.07136L7.91737 3.02703L11.293 0V1.52216H14.6494V4.5492Z",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMissedCall);
export default __webpack_public_path__ + "static/media/icon-missed-call.eb48199930462929214bf793abfd0910.svg";
export { ForwardRef as ReactComponent };